// src/ui/RateSelector.js
const PRESET_RATES = [0, 5, 7, 10, 14, 20, 21];

export class RateSelector {
  constructor({ langManager, onRateChange }) {
    this._lm = langManager;
    this._onRateChange = onRateChange;
    this._rate = 20;
    this._el = this._build();
  }

  get element() { return this._el; }
  get rate() { return this._rate; }

  _build() {
    const el = document.createElement('div');
    el.className = 'rate-selector';

    const label = document.createElement('span');
    label.className = 'section-label';
    label.dataset.i18n = 'rate.label';
    label.textContent = this._lm.t('rate.label');

    const chipsRow = document.createElement('div');
    chipsRow.className = 'chips-row';

    PRESET_RATES.forEach((r) => {
      const chip = document.createElement('button');
      chip.className = 'chip' + (r === this._rate ? ' active' : '');
      chip.textContent = `${r}%`;
      chip.dataset.rate = r;
      chip.type = 'button';
      chip.setAttribute('aria-label', `${r}% VAT rate`);
      chip.addEventListener('click', () => this._selectRate(r, chip));
      chipsRow.appendChild(chip);
    });

    const inputWrap = document.createElement('div');
    inputWrap.className = 'rate-input-wrap';

    const input = document.createElement('input');
    input.className = 'rate-input';
    input.type = 'number';
    input.min = '0';
    input.max = '100';
    input.step = '0.1';
    input.value = this._rate;
    input.setAttribute('aria-label', 'Custom VAT rate');
    input.addEventListener('input', () => {
      const val = parseFloat(input.value);
      if (!isNaN(val) && val >= 0) {
        this._rate = val;
        chipsRow.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
        this._onRateChange(val);
      }
    });

    const suffix = document.createElement('span');
    suffix.className = 'rate-suffix';
    suffix.textContent = '%';

    inputWrap.appendChild(input);
    inputWrap.appendChild(suffix);

    this._input = input;
    this._chipsRow = chipsRow;

    el.appendChild(label);
    el.appendChild(chipsRow);
    el.appendChild(inputWrap);

    return el;
  }

  _selectRate(rate, chipEl) {
    this._rate = rate;
    this._chipsRow.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
    chipEl.classList.add('active');
    this._input.value = rate;
    this._onRateChange(rate);
  }

  updateTranslations() {
    const label = this._el.querySelector('[data-i18n]');
    if (label) label.textContent = this._lm.t(label.dataset.i18n);
  }
}
